import { render, staticRenderFns } from "./Tipo_Competencias.vue?vue&type=template&id=3b124bd7&scoped=true"
import script from "./Tipo_Competencias.vue?vue&type=script&lang=js"
export * from "./Tipo_Competencias.vue?vue&type=script&lang=js"
import style0 from "./Tipo_Competencias.vue?vue&type=style&index=0&id=3b124bd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b124bd7",
  null
  
)

export default component.exports